<template>
	<div v-show="messages.length > 0" class="app-message-float" :class="{ overflow: overflow }">
		<div class="inner" ref="messageContainer">
			<app-message v-for="message in messages" :key="message.id" :message="message" />
		</div>
	</div>
</template>

<script setup lang="ts">
import $store from '@/store/index';
import { computed, ref, watch } from 'vue';
import AppMessage from './AppMessage.vue';

const messageContainer = ref(null);
const messages = computed(() => $store.state.messages);
const overflow = ref(false);

function isOverflown(element: Element) {
	return element.scrollHeight > element.clientHeight;
}
watch(messages.value, async () => {
	overflow.value = isOverflown(messageContainer.value!);
}, { flush: 'post' });
</script>
